import { render, staticRenderFns } from "./CustomerAgreement.vue?vue&type=template&id=9208fd9c&scoped=true&"
import script from "./CustomerAgreement.vue?vue&type=script&lang=ts&"
export * from "./CustomerAgreement.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerAgreement.vue?vue&type=style&index=0&id=9208fd9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9208fd9c",
  null
  
)

export default component.exports